import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { DemoServiceModel, ServiceModel } from 'src/app/shared/models/service.model';
import { UserServicesService } from '../services/user-services.service';
import { Subscription, filter } from 'rxjs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import { UserModel } from 'src/app/shared/models/user.model';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit, OnDestroy {
  public servicesIconsPath: string;
  public publicServices: Array<ServiceModel>;
  private subscriptions: Subscription[] = [];
  public currentServicePath: string;
  public isAdmin: boolean = false;
  public menu: {
    open: boolean;
  } = { open: false };
  constructor(
    private userServicesService: UserServicesService,
    private router: Router,
    private _authService: AuthService,
    private changeDetector: ChangeDetectorRef
  ) {
    this.servicesIconsPath = this.userServicesService.servicesIconsPath;
  }

  async ngOnInit(): Promise<void> {
    let u: UserModel;
    this._authService.getUserLogged().subscribe(async (user: UserModel) => {
      this.publicServices = await this.userServicesService.getUserServices('public');
      //this.publicServices.map(x => (x.path = this.getPath(x.path)));
      this.publicServices = this.publicServices?.map(x => {
        x.path = x.path + '/public';
        return x;
      });

      if (user) {
        u = user;
        if (u.client.id === 1) {
          this.isAdmin = true;
        }
      }

      // Get current route when refreshing
      // console.log('Router url: ', this.router.url);
      this.currentServicePath = this.userServicesService.routeToServicePath(this.router.url);
      // console.log('currentServicePath: ' + this.currentServicePath);

      // Get current route changes when navigating
      const routeEvents = this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(event => {
        // console.log('The URL changed to: ' + event['url']);
        this.currentServicePath = this.userServicesService.routeToServicePath(event['url']);
        this.changeDetector.detectChanges();
      });
      this.subscriptions.push(routeEvents);
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  public togglemenu() {
    this.menu.open = !this.menu.open;
  }
  public openmenu() {
    this.menu.open = true;
  }
  public closemenu() {
    this.menu.open = false;
  }
  /*   getPath(path: string): string {
    if (!path.includes('editor2dmaps')) return `${path}/public`;

    const editorService: DemoServiceModel = this._authService
      .getCurrentUser()
      ?.client.services.find(service => service.name == 'editor2dmaps');
    let newpath = null;
    if (editorService?.demo) {
      newpath = `${path}/public/video`;
    } else {
      newpath = `${path}/public`;
    }
    return newpath;
  } */
}
